export default {
  namespaced: true,
  state: () => ({
    isDownForMaintenance: false
  })
}
